module.exports = __webpack_public_path__ + "static/media/mulher_r1_c5.91802455.jpg";